import * as React from 'react';

export interface PaymentConfirmationProps {
    onComponentWillMount: (success: string | null, failed: string | null, paymentStatus: string | null, payuid: string | null, amount: string | null, axperror: string | null) => void;
}

class PaymentConfirmationComponent extends React.Component<PaymentConfirmationProps> {
    render() {
        return (
            <div>Redirecting.....</div>
        );
      }
    componentWillMount() {
        const urlParams: URLSearchParams = new URLSearchParams(window.location.search);
        const refnoSuccess: string | null = urlParams.get('success');
        const refnoFailed: string | null = urlParams.get('failed');
        const paymentStatus: string | null = urlParams.get('status');
        const payuid: string | null = urlParams.get('payuid');
        const amount: string | null = urlParams.get('amount');
        const axperror: string | null = urlParams.get('axperror');

        this.props.onComponentWillMount(refnoSuccess, refnoFailed, paymentStatus, payuid, amount, axperror);
    }
}

export default PaymentConfirmationComponent;



// WEBPACK FOOTER //
// ./src/components/PaymentConfirmation/PaymentConfirmationComponent.tsx